module.exports = __webpack_public_path__ + "img/i1.79faf342.png";